import { getReportsData } from '@/services/modules/athenas/demands/get-reports-data'
import { handleToast } from '@/utils/handleToast'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

export function useGetReportsData() {
  const { id } = useParams()

  const query = useQuery({
    queryKey: ['REPORTS_DATA', id],
    queryFn: () => getReportsData(id!)
  })

  useEffect(() => {
    if (query.isError) {
      handleToast({
        message:
          'Ocorreu um erro ao carregar os dados de Reporte. Tente novamente mais tarde.',
        type: 'error',
        autoClose: false
      })
    }
  }, [query.isError, query.error])

  return query
}
